import React from 'react';
import FontAwesome from 'react-fontawesome';
import * as MaterialUI from 'material-ui';
import { connect } from 'react-redux';
import { Row, Col } from 'reactstrap';
import { push } from 'react-router-redux';
import MoreVertIcon from 'material-ui/svg-icons/navigation/more-vert';

import * as trayectosActions from 'modules/trayectos/action';
import * as generalActions from 'modules/general/action';
import { EliminarConfirmacionC } from 'modules/general/component';

@connect((store) => ({
  eliminarId: store.getIn(['trayectos', 'eliminarId']),
  trayectosLista: store.getIn(['trayectos', 'lista']) || [],
}))
export default class extends React.Component {
  constructor(props) {
    super(props);
  }
  componentDidMount = () => {
    const { dispatch } = this.props;
    dispatch(trayectosActions.get());
    dispatch(generalActions.dashboard_changeTitle('TRAYECTOS'));
  };
  add = (id) => this.props.dispatch(push(`/dashboard/trayectos/add/${id || 'new'}`));
  delete = (trayecto) => this.props.dispatch(trayectosActions.setState({ eliminarId: trayecto ? trayecto.get('id') : false }));
  confirmDelete = () => {
    this.props.dispatch(trayectosActions.delete_(this.props.eliminarId));
    this.delete();
  };
  crearSimilar = (trayecto) => {
    this.props.dispatch(trayectosActions.setState({ trayecto }));
    this.props.dispatch(push('/dashboard/trayectos/add/new'));
  };
  render() {
    const { trayectosLista } = this.props;
    const onTouchTap = (trayecto) => this.add(trayecto.get('id'));
    return (
      <div>
        <Row className="rowContainer">
          <Col md={{ size: 6, offset: 3 }}>
            <MaterialUI.Paper zDepth={2} className="container">
              <MaterialUI.List className="noPadding dividerList">
                {trayectosLista.map((trayecto) => (
                  <div key={trayecto.get('id')}>
                    <MaterialUI.ListItem
                      onTouchTap={() => onTouchTap(trayecto)}
                      primaryText={<div onClick={() => onTouchTap(trayecto)}>{trayecto.get('nombre') || ''}</div>}
                      secondaryText={<div onClick={() => onTouchTap(trayecto)}>{trayecto.get('subnombre') || ''}</div>}
                      rightIconButton={
                        <MaterialUI.IconMenu
                          iconButtonElement={
                            <MaterialUI.IconButton touch={true} tooltipPosition="bottom-left">
                              <MoreVertIcon />
                            </MaterialUI.IconButton>
                          }
                        >
                          <MaterialUI.MenuItem className="textCenter" onTouchTap={() => this.delete(trayecto)}>
                            <FontAwesome name="trash" className="red" /> Eliminar
                          </MaterialUI.MenuItem>
                          <MaterialUI.MenuItem onTouchTap={() => this.crearSimilar(trayecto)}>
                            <FontAwesome name="copy" className="green" /> Copiar
                          </MaterialUI.MenuItem>
                        </MaterialUI.IconMenu>
                      }
                    />
                    <MaterialUI.Divider />
                  </div>
                ))}
              </MaterialUI.List>
            </MaterialUI.Paper>
          </Col>
        </Row>
        <EliminarConfirmacionC eliminarId={this.props.eliminarId} confirmar={this.confirmDelete} cancelar={this.delete} />
        <MaterialUI.FloatingActionButton className="bottonFlotanteAdd" onTouchTap={() => this.add()}>
          <FontAwesome name="plus" />
        </MaterialUI.FloatingActionButton>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// src/modules/trayectos/components/main.js